export const GRID_VIEW = 'grid';
export const LIST_VIEW = 'list';
export const PITCH_LIST_VIEW = 'pitch_list';